// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"UserItem_menuItem__fWYhu","menuItemText":"UserItem_menuItemText__3f7Ak","menuItemTextActive":"UserItem_menuItemTextActive__1RYhN","user":"UserItem_user__3mA62"};